// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__G-peX","buttons":"RemoveExpirationActionButtons_buttons__2oDUA"};